// extracted by mini-css-extract-plugin
export default {"container":"SlotBookingForm_container__OLdDQ","error":"SlotBookingForm_error__Imzgu"};